import {Box, BoxProps} from "@chakra-ui/react";
import {forwardRef} from "react";

const ContentWrapper = forwardRef((props: BoxProps, ref) => (
  <Box ref={ref} maxW="1200px" mx="auto" px={[4, 8, 8, 8, 0]} {...props} />
));

export default ContentWrapper;
